<template>
  <div class="zj-emergency-videomonitor-container">
    <div class="video-wrapper">
      <!-- <zj-camera-preview
        class="video-item"
        :cameraId="cameraId"
        :cameraName="cameraName"
        :autoplay="autoplay"
        :cameraIsOnline="cameraIsOnline"
      /> -->
      <flv-player-real-time-new
        class="video-item"
        :cameraId="cameraId"
        :cameraName="cameraName"
        :currentIndex="0"
        :item="item"
        viewMode="swiper"
        ref="videoCom"
      />
    </div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="cameraName"
      placement="top"
    >
      <div class="video-title">
        {{
          cameraName.length > 6
            ? cameraName.substring(0, 6) + "..."
            : cameraName
        }}
        <div class="video-item-spread" @click="handleSpread"></div>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "ZJEmergencyVideoMonitorPanel",
  componentName: "ZJEmergencyVideoMonitorPanel",
  props: {
    cameraId: String,
    cameraName: String,
    autoplay: {
      type: Boolean,
      default: false,
    },
    cameraIsOnline: {
      type: Boolean,
      default: false,
    },
    item:{
      type: Object,
      default: () => {},
    }
  },
  methods: {
    handleSpread() {
      this.$refs.videoCom.stop()
      this.$emit("spread", this.cameraId, this.cameraName, this.cameraIsOnline,this.item);
    },
    play(){
      this.$refs.videoCom.play()
    }
  },
};
</script>